const employees = {
  employeesList: {
    employeesListTitle: "Employees List",
    employees: "Employees",
    employee: "Employee",
    addMoreEmployees: "Add New Employee",
    noEmployeesFound: "No employees found",
    noSearchResults:
      "There is no search result or filter result that matches the entered data.",
    searchPlaceholder: "Search by employee Name",
    tableHeader: {
      employeeName: "Employee",
      email: "Email Address",
      role: "Role",
      status: "Status"
    },

    filters: {
      role: "Role",
      status: "Status",
      searchPlaceholders: {
        role: "Search by employee role"
      }
    }
  },
  addEmployee: {
    addEmployee: "Add Employee",
    editEmployee: "Edit Employee",
    addMore: "Add More",
    employeeDetails: "Employee Details",
    labels: {
      employeeImage: "Employee Image",
      fullName: "Full Name",
      emailAddress: "Email Address",
      mobileNumber: "Mobile Number",
      assignToRole: "Assign To Role"
    },
    placeholders: {
      name: "Enter the name",
      email: "Enter the email",
      number: "Enter the number",
      role: "Select the role"
    }
  },
  employeeDetails: {
    employeeDetails: "Employee Details",
    employeeInfo: "Employee Info",
    emailAddress: "Email Address",
    contactNumber: "Contact Number",
    status: "Status"
  },
  status: {
    active: "Active",
    inActive: "Inactive"
  },
  deactivateEmployee: {
    content: "Deactivate",
    confirmationContent:
      "Are you sure you want to deactivate this employee?"
  },
  reactivateEmployee: {
    content: "Reactivate",
    confirmationContent:
      "Are you sure you want to reactivate this employee?"
  }
};

export default employees;
